import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {retryMessageMutation, RetryMessageInput} from './__generated__/retryMessageMutation.graphql';

const mutation = graphql`
	mutation retryMessageMutation($input: RetryMessageInput!) {
		retryMessage(input: $input) {
			clientMutationId
			message {
				id
				deliveryStatus
				retryCount
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: RetryMessageInput,
	onCompleted?: (r: retryMessageMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<retryMessageMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'retryMessageMutation'};
